import mutate from 'js-core/js/apollo/mutations/mutate';

import UpdateSampleMutation from 'gql/mutations/Sample/UpdateSample.gql';
import DeleteSampleMutation from 'gql/mutations/Sample/DeleteSample.gql';

export default class{

    static update(input) {

        return mutate(UpdateSampleMutation, { input });
    }

    static delete(id) {

        return mutate(DeleteSampleMutation, { id });
    }
}
